import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useApi } from '../../context/ApiProvider';
import Card from '../Helpers/Card';
import { Formik, Form, Field } from 'formik';
import moment from 'moment';
import { PDFDownloadLink } from '@react-pdf/renderer';
import UserActivityPDF from './UserActivityPDF';

function Partner() {
    const [loading, setLoading] = useState(true);
    const [partner, setPartner] = useState(false);
    const [partnerClients, setPartnerClients] = useState([]);
    const [clients, setClients] = useState([]);
    const [administrators, setAdministrators] = useState([]);
    const { partnerId } = useParams();
    const Api = useApi();
    const navigate = useNavigate();
    const [partnerClientsActivity, setPartnerClientsActivity] = useState([]);
    const [dates, setDates] = useState({ fromDate: moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"), toDate: moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD") })

    /* Meddelanden */
    const [connectClientSuccess, setConnectClientSuccess] = useState(false);
    const [connectClientError, setConnectClientError] = useState(false);
    const [disconnectClientSuccess, setDisconnectClientSuccess] = useState(false);
    const [disconnectClientError, setDisconnectClientError] = useState(false);
    const [deletePartnerSuccess, setDeletePartnerSuccess] = useState(false);
    const [deletePartnerError, setDeletePartnerError] = useState(false);
    const [updatePartnerSuccess, setUpdatePartnerSuccess] = useState(false);
    const [updatePartnerError, setUpdatePartnerError] = useState(false);

    useEffect(() => {
        if (!partnerId) {
            return;
        }

        refresh();

    }, [partnerId])

    useEffect(() => {
        if (!partnerClients.length > 0) {
            return;
        }

        fetchClientActivity();

    }, [partnerClients, dates])

    function refresh() {
        fetchClients();
        fetchPartner();
        fetchPartnerClients();
        fetchAdministrators();
    }

    function fetchPartner() {
        Api.get(`/rolf/partners/${partnerId}`)
            .then(response => {
                setPartner(response);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    function fetchPartnerClients() {
        Api.get(`/rolf/partners/${partnerId}/clients`).then(response => {
            setPartnerClients(response);
        })
    }

    function fetchClients() { //Hämta alla klienter, till selectboxen
        Api.get("/clients").then(data => {
            setClients(data);
        });
    }

    async function fetchClientActivity() {
        let dateUrlParams = `?fromDate=${moment(dates.fromDate).startOf("day").unix()}&toDate=${moment(dates.toDate).endOf("day").unix()}`;

        // Hämta all data parallellt
        const promises = partnerClients.map(client =>
            Api.get(`/rolf/useractivity/${client.clientId}${dateUrlParams}`)
                .then(data => ({
                    name: client.name,
                    data: data
                }))
        );

        try {
            const results = await Promise.all(promises);
            setPartnerClientsActivity(results);
        } catch (error) {
            console.error("Failed to fetch data. Try again later.");
        }
    }

    function fetchAdministrators() {
        Api.get(`/rolf/partners/${partnerId}/administrators`).then(data => {
            setAdministrators(data);
        });
    }

    function disconnectClient(clientId) {
        if (window.confirm("Are you sure you want to disconnect this client from the partner?")) {
            Api.delete(`/rolf/clients/${clientId}/partner/${partnerId}`)
                .then(response => {
                    setDisconnectClientSuccess("Client disconnected from partner");
                    refresh();
                })
                .catch(error => {
                    console.log(error);
                    setDisconnectClientError("Error disconnecting client from partner");
                })
                .finally(() => {
                    setTimeout(() => {
                        setDisconnectClientSuccess(false);
                        setDisconnectClientError(false);
                    }, 5000);
                })
        }
    }

    function deletePartner() {
        Api.delete(`/rolf/partners/${partnerId}`)
            .then(response => {
                setDeletePartnerSuccess("Partner deleted");
                navigate('/rolf/partners');
            })
            .catch(error => {
                console.log(error);
                setDeletePartnerError("Error deleting partner");
            })
            .finally(() => {
                setTimeout(() => {
                    setDeletePartnerError(false);
                    setDeletePartnerSuccess(false);
                }, 5000);
            })
    }

    if (loading) {
        return <div>Loading...</div>
    }


    return (
        !partner ? null :
            <div className="grid-container">
                <section className='grow'>
                    <h3>{partner.name}</h3>
                    <p><Link className="button small" to={`/partners/billing?previewPartnerId=${partnerId}`}>Visa partnerläge för fakturering</Link></p>
                    <h4>Connected clients</h4>
                    {disconnectClientSuccess && <div className="formControlSuccess">{disconnectClientSuccess}</div>}
                    {disconnectClientError && <div className="formControlError">{disconnectClientError}</div>}
                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: '100%' }}>Client name</th>
                                <th>Disconnect</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                partnerClients.length == 0 ? <tr><td colSpan={2}>No clients, yet!</td></tr> : clients && partnerClients.map((client, index) => {
                                    let matchedClient = clients.find(c => c.ID === client.clientId)

                                    if (!matchedClient) return null;

                                    return (
                                        <tr key={matchedClient.ID}>
                                            <td>{matchedClient.name}</td>
                                            <td style={{ textAlign: "center" }}><a href="#" onClick={() => disconnectClient(matchedClient.ID)}><i className="fa fa-chain-broken warning" aria-hidden="true"></i></a></td>
                                        </tr>
                                    )
                                }
                                )}
                        </tbody>
                    </table>
                    <h4>Connected administrators</h4>
                    <table>
                        <thead>
                            <tr>
                                <th>Administrator name</th>
                                <th>Administrator email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {administrators.length == 0 ? <tr><td colSpan={2}>No administrators, yet!</td></tr> : administrators.map((admin, index) => {
                                return (
                                    <tr key={admin.ID}>
                                        <td>{admin.firstName} {admin.lastName}</td>
                                        <td>{admin.email}</td>
                                    </tr>
                                )
                            }
                            )}
                        </tbody>
                    </table>
                </section>
                <section>
                    <div>
                        <h4>Connect partner to client</h4>
                        <Card>
                            {connectClientSuccess && <div className="formControlSuccess">{connectClientSuccess}</div>}
                            {connectClientError && <div className="formControlError">{connectClientError}</div>}
                            <Formik
                                initialValues={{ clientId: '', partnerId: partnerId }}
                                enableReinitialize={true}
                                onSubmit={(values, { setSubmitting, resetForm }) => {
                                    Api.post(`/rolf/clients/${values.clientId}/partner`, values)
                                        .then(response => {
                                            setConnectClientSuccess("Client connected to partner");
                                            resetForm();
                                            refresh();
                                        })
                                        .catch(error => {
                                            console.log(error);
                                            setConnectClientError("Error connecting client to partner");
                                        })
                                        .finally(() => {
                                            setSubmitting(false);
                                            setTimeout(() => {
                                                setConnectClientSuccess(false);
                                                setConnectClientError(false);
                                            }, 5000);
                                        })
                                }}>
                                {({ isSubmitting }) => (
                                    <Form>
                                        <label htmlFor="clientId">Client</label>
                                        <Field as="select" name="clientId" className="formControl">
                                            <option value="">Select client</option>
                                            {clients && clients.map((client, index) => {
                                                return <option key={client.ID} value={client.ID}>{client.name}</option>
                                            })}
                                        </Field>
                                        <button type="submit" disabled={isSubmitting}>Connect client</button>

                                    </Form>
                                )}
                            </Formik>
                        </Card>
                    </div>
                    <div>
                        <h4>Edit partner information</h4>
                        <Card>
                            {updatePartnerSuccess && <div className="formControlSuccess">{updatePartnerSuccess}</div>}
                            {updatePartnerError && <div className="formControlError">{updatePartnerError}</div>}
                            <Formik
                                initialValues={{ name: partner.name, startDate: moment.unix(partner.startDate).format("YYYY-MM-DD") }}
                                enableReinitialize={true}
                                onSubmit={(values, { setSubmitting }) => {
                                    values.startDate = moment(values.startDate).unix();

                                    Api.put(`/rolf/partners/${partnerId}`, values)
                                        .then(response => {
                                            setUpdatePartnerSuccess("Partner updated");
                                            refresh();
                                        })
                                        .catch(error => {
                                            console.log(error);
                                            setUpdatePartnerError("Error updating partner");
                                        })
                                        .finally(() => {
                                            setSubmitting(false);
                                        })
                                }}>
                                {({ isSubmitting }) => (
                                    <Form>
                                        <label htmlFor="name">Name</label>
                                        <Field type="text" name="name" id="name" className="formControl" />
                                        <label htmlFor="startDate">Start date</label>
                                        <Field type="date" name="startDate" className="formControl" />
                                        <button type="submit" disabled={isSubmitting}>Save</button>
                                    </Form>
                                )}
                            </Formik>

                        </Card>
                    </div>

                    <h4>Generate user activity report</h4>
                    <Card>

                        <form>
                            <label htmlFor="fromDate">From date:</label>
                            <input type="date" name="fromDate" id="fromDate" value={dates.fromDate} onChange={(e) => setDates({ ...dates, fromDate: e.target.value })} className="formControl" />
                            <label htmlFor="toDate">To date:</label>
                            <input type="date" name="toDate" id="toDate" value={dates.toDate} onChange={(e) => setDates({ ...dates, toDate: e.target.value })} className="formControl" />
                        </form>

                        <PDFDownloadLink
                            document={
                                <UserActivityPDF
                                    partnerName={partner.name}
                                    dates={dates}
                                    partnerClientsActivity={partnerClientsActivity}

                                />
                            }
                            fileName={`${moment().format("YYYY-MM-DD")}-ROLF-användaraktivitet-${partner.name}.pdf`}
                            className="button"
                            style={{ textDecoration: "none", }}
                        >
                            {({ loading }) => loading ? "Generating PDF..." : "Download PDF"}
                        </PDFDownloadLink>
                    </Card>

                    <div>
                        <h4>Delete partner</h4>
                        <Card>
                            {deletePartnerSuccess && <div className="formControlSuccess">{deletePartnerSuccess}</div>}
                            {deletePartnerError && <div className="formControlError">{deletePartnerError}</div>}
                            <Formik
                                initialValues={{ confirmDelete: false }}
                                onSubmit={(values, { setSubmitting }) => {
                                    if (values.confirmDelete) {
                                        deletePartner();
                                    }
                                }}>
                                {({ isSubmitting, values }) => (
                                    <Form>

                                        <Field type="checkbox" name="confirmDelete" id="confirmDelete" /> <label htmlFor="confirmDelete">Confirm delete</label><br />
                                        <button type="submit" disabled={isSubmitting || !values.confirmDelete}>Delete</button>
                                        <p className='meta formControl'>Deletion of a partner cannot be undone.</p>
                                    </Form>
                                )}
                            </Formik>
                        </Card>
                    </div>
                </section>
            </div>
    )
}

export default Partner
